import { Icon, IconProps } from "@chakra-ui/react";

export default function GroupSession(props: IconProps) {
  return (
    <Icon viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M9 10.5C9 9.43913 8.57857 8.42172 7.82843 7.67157C7.07828 6.92143 6.06087 6.5 5 6.5C3.93913 6.5 2.92172 6.92143 2.17157 7.67157C1.42143 8.42172 1 9.43913 1 10.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 6.5C6.38071 6.5 7.5 5.38071 7.5 4C7.5 2.61929 6.38071 1.5 5 1.5C3.61929 1.5 2.5 2.61929 2.5 4C2.5 5.38071 3.61929 6.5 5 6.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path

        d="M10.9999 9.99998C10.9999 8.31498 9.9999 6.74998 8.9999 5.99998C9.32861 5.75336 9.59146 5.42952 9.76519 5.05711C9.93891 4.6847 10.0182 4.27521 9.99591 3.86488C9.97366 3.45454 9.85061 3.05602 9.63764 2.70458C9.42467 2.35313 9.12835 2.05961 8.7749 1.84998"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
